import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function SurveyAPI(): BringozApi {
  return {
    base: `/surveys`,
    infiniteScroll: {
      address: `/surveys`,
      cmd: 'GET'
    },
    actions: {
      getTypes: {
        address: 'types',
        cmd: 'GET',
        updateable: false
      },
      // getTotals : {
      //   address : '',
      //   cmd : 'GET',
      //   updateable: true
      // },
      getTotals: {
        address: 'totals',
        cmd: 'GET',
        updateable: false
      },
      exportData: {
        address: 'export',
        cmd: 'POST',
        updateable: true
      }
    }
  }
}

angular
  .module('bringoz.admin.survey')
  .factory('SurveyAPI', SurveyAPI);
